// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Ka-RuBAxhBTyokkJFkpwR","title":"CpE7ONerKLBoTqXdqhoqs","name":"u9fM23ThuEUVsPreplAwF"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Ready/Title/styles.css
// module id = 2890
// module chunks = 0